// extracted by mini-css-extract-plugin
export var divider = "_j0-7";
export var itemsToggle = "_j0-8";
export var mergeModal = "_j0-1";
export var optionCard = "_j0-4";
export var radioGroup = "_j0-6";
export var radioOption = "_j0-0";
export var selected = "_j0-5";
export var shipmentOptions = "_j0-2";
export var tableOptions = "_j0-3";